<ng-template #socialProofMessage>
  @switch (messageKey) {
    @case (SocialProofMessage.Rating) {
      <span class="tw-inline-block tw-align-middle tw-mr-1 -tw-translate-y-[2px]">⭐</span>
      <ng-container i18n="@@reviewOrderSocialProofRating">Rated <strong>4.5</strong> by <strong>1 Lakh+</strong> users</ng-container>
    }
    @case (SocialProofMessage.Improvement) {
      <span class="tw-inline-block tw-align-middle tw-mr-1 -tw-translate-y-[2px]">📈</span>
      <ng-container i18n="@@reviewOrderSocialProofImprovement"><strong>92%</strong> users saw improvement in 6-8 weeks</ng-container>
    }
    @case (SocialProofMessage.Trusted) {
      <span class="tw-inline-block tw-align-middle tw-mr-1 -tw-translate-y-[3px]">👥</span>
      <ng-container i18n="@@reviewOrderSocialProofTrusted">Trusted by <strong>17 Lakh+</strong> users</ng-container>
    }
  }
</ng-template>

<div #container
     class="tw-bg-gray-100 tw-h-[22px] tw-w-full tw-overflow-hidden tw-flex tw-items-center"
     [class.tw-justify-center]="!isOverflowing()">
  <div #content
       class="tw-whitespace-nowrap tw-leading-[22px]"
       [class.tw-flex]="isOverflowing()"
       [class.tw-w-max]="isOverflowing()"
       [class.tw-animate-marquee]="isOverflowing()">
    <span class="tw-font-lexend tw-text-gray-500 tw-text-200"
          [class.tw-px-4]="isOverflowing()">
      <ng-container *ngTemplateOutlet="socialProofMessage"></ng-container>
    </span>
    @if (isOverflowing()) {
      <span class="tw-font-lexend tw-text-gray-500 tw-text-200 tw-px-4"
            aria-hidden="true">
        <ng-container *ngTemplateOutlet="socialProofMessage"></ng-container>
      </span>
    }
  </div>
</div>
